export const SIDE_OPTION_TYPES = {
	text: 'text',
	link: 'link',
	rating: 'rating',
	grade: 'grade',
};
